import store from '../store/index'

let security =  {
    can(permKey) {
        let bits = permKey.split(':')
        let group = bits[0]
        let key = bits[1]

        return store.state.auth.is_admin || (store.state.auth.permissions && store.state.auth.permissions[group]
            && store.state.auth.permissions[group][key])
    }
};

export default {
    install (Vue) {
        Vue.prototype.$can = security.can
    }
}



// WEBPACK FOOTER //
// ./src/plugins/security.js